import axios from "axios";
import { readToken, storeToken } from "@/app/session";

// VendingPlanner API, served by the site's backend under /api/planner and protected by the
// operator sign-in from /admin.
export const API = `${process.env.REACT_APP_BACKEND_URL}/api/planner`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = readToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// An expired session sends the operator back to the /admin sign-in.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      storeToken("");
      window.location.assign("/admin");
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export const getToken = readToken;

// Product images are https links (Open Food Facts or pasted), or photos uploaded here, stored as
// "/api/planner/products/images/{id}" on the backend (VendingPlanner's old photo storage isn't carried over).
export const fileUrl = (path) => {
  if (!path) return undefined;
  if (/^https:\/\//i.test(path)) return path;
  if (path.startsWith("/api/planner/products/images/")) return `${process.env.REACT_APP_BACKEND_URL}${path}`;
  return undefined;
};
